import { render, staticRenderFns } from "./PorAnoProjetoGovernador.vue?vue&type=template&id=65c3c66b&scoped=true"
import script from "./PorAnoProjetoGovernador.vue?vue&type=script&lang=js"
export * from "./PorAnoProjetoGovernador.vue?vue&type=script&lang=js"
import style0 from "./PorAnoProjetoGovernador.vue?vue&type=style&index=0&id=65c3c66b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c3c66b",
  null
  
)

export default component.exports